import React, { Component, ChangeEvent } from 'react';
import './narrative-board-tab.css';
import { connect } from 'react-redux';
import { Message, Segment, Card, Menu, Button, Header, Dimmer, Loader, Input, InputProps } from 'semantic-ui-react';
import {
    setNarrativeBoardMessage, getNarrativeBoardCards,
    emptyNarrativeBoardCards, deleteNarrativeBoardCard, getNarrativeBoardCardHistory,
    setLoaderState, getNarrativeBoardCardsAndTeamMembers
} from '../../../actions/narrative-board.actions';
import { NARRATIVEBOARDCONFIG } from '../narrative-board-config';
import NarrativeBoardComments from '../narrative-board-comments/narrative-board-comments';
import { slider_settings } from '../slider-custom-config';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import * as microsoftTeams from "@microsoft/teams-js";
import { NarrativeBoardCard, NarrativeBoardHistoryCard, DeleteRequestInfo, TeamMember } from '../../../modal/narrative-board';
import DeleteConfirmationModal from '../../delete-cofirmation-modal/delete-cofirmation-modal';
import { CONFIG } from '../../../helper/config';
import _ from 'lodash';
import TeamsCard from '../../team-card/team-card';
import { activeLoader,storeSessionId } from '../../../actions/view.actions';
import history from '../../../helper/history';

interface IProps {
    narrative_board_cards: NarrativeBoardCard[];
    narrative_board_team_members: TeamMember[];
    narrative_board_msg: string;
    theme: string;
    show_loader: boolean;
    nb_card_current_page_count: number;
    nb_card_history_current_page_count: number[];
    is_get_more_cards: boolean;
    is_license_expire: boolean;
    is_unregisterd_user: boolean;
    unregisterd_user_msg: string;
    is_update_chart_view_state: boolean;
    active_loader: boolean;
    sessionId:string;
    setNarrativeBoardMessage: (arg: string) => void;
    getNarrativeBoardCards: (arg0: DeleteRequestInfo, arg1: number, arg3: string, auth_token: string, is_loader?: boolean, id?: any) => void;
    emptyNarrativeBoardCards: () => void;
    deleteNarrativeBoardCard: (arg0: number, arg1: DeleteRequestInfo, auth_token: string) => void;
    getNarrativeBoardCardHistory: (arg0: number, arg1: number, arg2: any, auth_token: string) => void;
    setLoaderState: (arg: boolean) => void;
    getNarrativeBoardCardsAndTeamMembers: (arg0: DeleteRequestInfo, arg2: number, arg3: string, auth_token: string, is_loader?: boolean, id?: any) => void;
    activeLoader: (active_loader: boolean) => void;
    storeSessionId:(arg: string) => void;
}

interface IState {
    search_input: string;
    teams_context: any;
    port_no: string;
    selected_card?: NarrativeBoardCard;
    open_delete_confirmation_modal: boolean;
    current_active_slide: { insight_id: number, active_slide: number }[];
    auth_token: string;
}

/**
 * NarrativeBoardTab Component
 * This component represents the Narrative Board Tab in the application. It allows users to view,
 * search, and manage narrative board cards. Users can also delete cards and view card history.
 * The component interacts with Microsoft Teams to retrieve context and authentication tokens. 
 * It uses Redux for state management and Semantic UI for styling.
 * @component
 * @example
 * return (<NarrativeBoardTab {...props} />)    
 */
export class NarrativeBoardTab extends Component<IProps, IState>{
    timer: any = null;
    constructor(props: IProps) {
        super(props);
        this.state = {
            search_input: '',
            teams_context: {},
            port_no: '',
            current_active_slide: [],
            open_delete_confirmation_modal: false,
            auth_token: ''
        }
    }

    /**
     * Extracts the search input string from the Microsoft Teams context.
     * The `subEntityId` is expected in the format: `id::search_input`.
     *
     * @param {any} teams_context - The Microsoft Teams context object.
     * @returns {string} The extracted search input string, or an empty string if not available.
     */
    getSearchInput= (teams_context)=>{
        if(teams_context.subEntityId && teams_context.subEntityId !== ''){
            return teams_context.subEntityId.split('::')[1]
        }else return ''
    }

    /**
     * Extracts the entity ID from the Microsoft Teams context.
     * The `subEntityId` is expected in the format: `id::search_input`.
     *
     * @param {any} context - The Microsoft Teams context object.
     * @returns {string | undefined} The extracted ID, or `undefined` if not available.
     */
    getIdForMicrosoftTeamsContext = (context)=>{
        if(context.subEntityId && context.subEntityId !== ''){
            return context.subEntityId.split('::')[0]
        }else return undefined
    }

    /**
     * This function is called when the component is mounted. It initializes the Microsoft Teams app,
     * retrieves the context, and fetches the narrative board cards and team members.
     */
    componentDidMount() {
        const query_params = new URLSearchParams(history.location.search);
        let port_no: any = query_params.get('port_no');
        let teams_context: any = query_params.get('context')?.split(CONFIG.URLQUERYPARAMSEPERATOR)[0];
        teams_context = teams_context ? JSON.parse(teams_context) : {};
        let token = query_params.get('auth_token');
        microsoftTeams.app.initialize();
        microsoftTeams.app.notifySuccess();
        if (teams_context.userObjectId && token) {
            this.setState({ teams_context: teams_context, port_no: port_no, auth_token: token, search_input: this.getSearchInput(teams_context) });
            if (teams_context.team_id) {
                let id = this.getIdForMicrosoftTeamsContext(teams_context);
                this.props.getNarrativeBoardCardsAndTeamMembers(this.NBCardRequestBodyParams(teams_context), this.props.nb_card_current_page_count, this.state.search_input, token, true, id);
            }
        } else {
            microsoftTeams.app.initialize().then(() => {
                microsoftTeams.app.notifySuccess();
            }).catch((error) => {
                console.error('error', error);
            });
            
            let comp_ref = this;
            microsoftTeams.app.getContext().then((context) => {
                teams_context.user_id = context.user?.id;
                teams_context.userObjectId = context.user?.id;
                teams_context.userPrincipalName = context.user?.userPrincipalName;
                teams_context.team_id = context.team?.groupId
                teams_context.tid = context.user?.tenant?.id;
                teams_context.teamId = context.team?.internalId;
                teams_context.id = context.page?.subPageId && context.page.subPageId !== '' ? context.page.subPageId.split('::')[0] : -1;
                teams_context.entityId = context.page?.id;
                teams_context.channelId = 'msteams';
                teams_context.teamName = context.team?.displayName;
                microsoftTeams.authentication.getAuthToken().then( (auth_token: string) => {
                        if(!this.props.sessionId){
                            let session_id = new Date().toString();
                              this.props.storeSessionId(session_id)
                            }
                        comp_ref.setState({ teams_context: teams_context, port_no: port_no, auth_token: auth_token, search_input: this.getSearchInput(context)});
                        if (teams_context.team_id) {
                            let id = this.getIdForMicrosoftTeamsContext(context);
                            comp_ref.props.getNarrativeBoardCardsAndTeamMembers(this.NBCardRequestBodyParams(teams_context), this.props.nb_card_current_page_count, this.state.search_input, auth_token, true, id);
                        }
                    }).catch((error) => {
                        console.error('error', error);
                })
            });
        }}
    
    /**
     * This function is called when the component is unmounted. It clears the timer and
     * empties the narrative board cards.
     * */
    handleScroll = (e: any) => {
        let element = e.target
        if (element.id === 'narrative-board-container') {
            if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                let { narrative_board_cards, is_get_more_cards, nb_card_current_page_count, show_loader } = this.props;
                if (is_get_more_cards && narrative_board_cards.length > 0 && !show_loader) {
                    let { teams_context, auth_token } = this.state;
                    this.props.setLoaderState(true);
                    this.props.getNarrativeBoardCards(this.NBCardRequestBodyParams(teams_context), nb_card_current_page_count, this.state.search_input, auth_token, false);
                }
            }
        }
    }

    /**
     * This function is called when the component is unmounted. It clears the timer and
     * empties the narrative board cards.
     * */
    NBCardRequestBodyParams = (teams_context) => {

        return {
            user_id: teams_context.userObjectId,
            tenant_id: teams_context.tid,
            channelId: teams_context.channelId,
            entityId: teams_context.entityId,
            id: teams_context.id,
            teamId: teams_context.teamId,
            teamName: teams_context.teamName,
            team_id: teams_context.team_id,
            userPrincipalName: teams_context.userPrincipalName,
        } as any;
    }

    /**
     * This function is called when the delete confirmation modal is closed. It removes the narrative board card
     * if the is_delete parameter is true.
     * @param {boolean} is_delete - A boolean indicating whether to delete the card or not.
     */
    removeNarrativeBoardCard = (is_delete: boolean) => {
        let { selected_card, teams_context, auth_token } = this.state;
        if (is_delete && selected_card) {
            this.props.deleteNarrativeBoardCard(selected_card.insight_id, this.addTenantID(teams_context), auth_token);
        }
        this.setState({ open_delete_confirmation_modal: false });
    }

    /**
     * This function is called when the delete confirmation modal is opened. It sets the selected card and opens the modal.
     * @param {NarrativeBoardCard} selected_card - The selected narrative board card.
     */
    openDeleteConfirmationModal = (selected_card: NarrativeBoardCard) => {
        this.setState({ open_delete_confirmation_modal: true, selected_card: selected_card })
    }

    /**
     * This function formats the date to a specific format.
     * @param {string} date - The date to be formatted.
     * @returns {string} - The formatted date.
     */
    getDateInSpecificFormat = (date: string) => {
        return new Date(date).toLocaleDateString('en-us', { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' });
    }

    /**
     * This function handles the slide change event. It fetches the history of the narrative board card if needed.
     * @param {number} insight_id - The insight ID of the narrative board card.
     * @param {number} next - The next slide index.
     */
    handleSildeChange = (insight_id: number, next: number) => {
        let { narrative_board_cards, nb_card_history_current_page_count } = this.props;
        let { teams_context, current_active_slide, auth_token } = this.state;
        let nb_index = narrative_board_cards.findIndex(nb => nb.insight_id === insight_id);
        let nb_history = narrative_board_cards[nb_index].history;
        if (_.isArray(nb_history) && next === (nb_history.length - 1)) {
            if (nb_history.length < narrative_board_cards[nb_index].total_history_length) {
                let history_page = nb_card_history_current_page_count[nb_index] ? nb_card_history_current_page_count[nb_index] : 1;
                this.props.getNarrativeBoardCardHistory(insight_id, history_page, this.addTenantID(teams_context), auth_token);
            }
        }
        let index = current_active_slide.findIndex(cas => cas.insight_id === insight_id);
        if (index === -1) {
            current_active_slide = current_active_slide.concat({ insight_id: insight_id, active_slide: next });
            this.setState({ current_active_slide: current_active_slide });
        } else if (current_active_slide[index].active_slide !== next) {
            current_active_slide[index].active_slide = next;
            this.setState({ current_active_slide: current_active_slide });
        }
    }

    /**
     * This function adds the tenant ID to the teams context.
     * @param {any} teams_context - The teams context.
     * @returns {any} - The updated teams context.
     */
    addTenantID = (teams_context: any) => {
        let context = JSON.parse(JSON.stringify(teams_context || {}));
        context.tenant_id = teams_context.tid;
        delete context.tid;
        return context;
    }

    /**
     * This function renders the message based on the narrative board message.
     * @returns {JSX.Element} - The rendered message.
     */
    renderMessage = () => {
        let { narrative_board_msg } = this.props;
        if (narrative_board_msg.trim() !== '') {
            if (narrative_board_msg.includes('<br>')) {
                let splited_msg = narrative_board_msg.split('<br>');
                let list = splited_msg.slice(1);
                return <div id='narrative-board-message-container'>
                    <Message error header={splited_msg[0]} list={list} onDismiss={() => this.props.setNarrativeBoardMessage('')} />
                </div>
            } else {
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                setTimeout(() => {
                    this.props.setNarrativeBoardMessage('');
                }, 5000);
                let is_success = narrative_board_msg === NARRATIVEBOARDCONFIG.DELETESUCCESSMESSAGE;
                return <div id='narrative-board-message-container'>
                    <Message success={is_success} error={!is_success} content={narrative_board_msg} onDismiss={() => this.props.setNarrativeBoardMessage('')} />
                </div>
            }
        } else {
            return null;
        }
    }

    /**
     * This function renders the narrative board card with history cards.
     * @param {NarrativeBoardHistoryCard[]} narrative_board_card_history - The history of the narrative board card.
     * @param {number} nb_index - The index of the narrative board card.
     * @returns {JSX.Element[]} - The rendered history cards.
     */
    renderCardWithHistoryCards = (narrative_board_card_history: NarrativeBoardHistoryCard[] | { details: string }, nb_index: number) => {
        let content: JSX.Element[] = [];
        if (!_.isArray(narrative_board_card_history) && narrative_board_card_history.details) {
            content.push(<Segment placeholder textAlign='center'><div className='inconsistent-role-msg-div'>{narrative_board_card_history.details}</div></Segment>);
        }
        else if (_.isArray(narrative_board_card_history) && narrative_board_card_history.length > 0) {
            content = narrative_board_card_history.map((nb, i) => {
                return <TeamsCard key={nb} display_card_name={true}
                    is_update_chart_view_state={this.props.is_update_chart_view_state}
                    {...nb.json} token={this.state.auth_token} team_context={this.state.teams_context} ></TeamsCard>
            })
        } else {
            content.push(<div>No History card available...</div>);
        }
        return content;
    }

    /**
     * This function handles the change event of the search input.
     * @param {ChangeEvent} event - The change event.
     * @param {InputProps} data - The input props.
     */
    handleSearchInputChange = (event: ChangeEvent, data: InputProps) => {
        event.preventDefault();
        const { name, value } = data;
        this.setState({ [name]: value } as Pick<IState, keyof IState>);
    }

    /**
     * This function searches for narrative board cards from the backend.
     */
    searchNarrativeBoardCardsFromBackend = () => {
        let { search_input, teams_context, auth_token } = this.state;
        this.props.emptyNarrativeBoardCards();
        this.props.getNarrativeBoardCards(this.NBCardRequestBodyParams(teams_context), 1, search_input, auth_token, true);
    }

    /**
     * This function gets the history card of the narrative board card.
     * @param {NarrativeBoardCard} narrative_board_card - The narrative board card.
     * @param {number} insight_id - The insight ID of the narrative board card.
     * @returns {NarrativeBoardHistoryCard} - The history card of the narrative board card.
     */
    getHistoryCard = (narrative_board_card: NarrativeBoardCard, insight_id: number) => {
        let { current_active_slide } = this.state;
        let index = current_active_slide.findIndex(cas => cas.insight_id === insight_id);
        if (index === -1) {
            return narrative_board_card.history[0];
        } else {
            let current_slide = current_active_slide[index].active_slide;
            return narrative_board_card.history[current_slide];
        }
    }

    /**
     * This function renders the delete confirmation modal.
     * @returns {JSX.Element} - The rendered delete confirmation modal.
     */
    renderDeleteConfirmationModal = () => {
        let { open_delete_confirmation_modal } = this.state;

        return open_delete_confirmation_modal ? <DeleteConfirmationModal open={open_delete_confirmation_modal}
            content={NARRATIVEBOARDCONFIG.DELETEMODELCONTENT}
            close={this.removeNarrativeBoardCard} /> : null
    }

    /**
     * This function renders the pagination loader.
     * @returns {JSX.Element} - The rendered pagination loader.
     */
    renderPaginationLoader = () => {
        let { show_loader } = this.props;
        return show_loader ?
            <Dimmer id='relative-dimmer' active={show_loader} inverted>
                <Loader inline='centered' size='large'>{CONFIG.LOADER_TEXT}</Loader>
            </Dimmer> : null
    }

    /**
     * This function renders the message when no card is found.
     * @returns {JSX.Element} - The rendered message.
     */
    renderNoCardMessage = () => {
        return !this.props.active_loader ? <Segment placeholder textAlign='center' size='large'>
            {NARRATIVEBOARDCONFIG.NOCARDFOUND}
        </Segment> : <></>
    }

    /**
     * Renders the Narrative Board Tab component. This component displays a list of narrative board cards,
     * allows searching for specific cards, and provides functionality to delete cards.
     * 
     * @returns {JSX.Element} The rendered component.
     */
    render() {
        let { narrative_board_msg, narrative_board_cards, is_license_expire,
            narrative_board_team_members, is_unregisterd_user, unregisterd_user_msg, active_loader } = this.props;
        let { teams_context, auth_token } = this.state;
        if (is_unregisterd_user) {
            return <Segment dangerouslySetInnerHTML={{ __html: unregisterd_user_msg }}
                placeholder textAlign="center" size="large" />
        }
        else if (is_license_expire) {
            return <Segment placeholder textAlign="center" size="large" content={CONFIG.LICENSE_EXPIRE} />
        }
        else if (!active_loader && teams_context.userObjectId) {

            return (<div id='narrative-board-container' onScroll={this.handleScroll}>
                <Menu secondary>
                    <Menu.Menu position='right'>
                        <Input
                            placeholder={NARRATIVEBOARDCONFIG.SEARCH}
                            action={<Button icon='search'
                                onClick={(e: any) => this.searchNarrativeBoardCardsFromBackend()} />}
                            id='search-input' className='search' name='search_input'
                            value={this.state.search_input} maxLength={CONFIG.MAXLENGTH.TEXT}
                            onChange={this.handleSearchInputChange}
                            onKeyDown={(event: any) => (event.key === "Enter") ? this.searchNarrativeBoardCardsFromBackend() : null} />
                    </Menu.Menu>
                </Menu>
                {(narrative_board_cards.length > 0) ?

                    <Card.Group id='narrative-board-grid' itemsPerRow={1}>
                        {narrative_board_cards.map((nb, i) => {
                            return <Card key={nb.va_name}>
                                <Card.Content>
                                    <Card.Header>
                                        <Menu id='narrative-board-card-header' inverted pointing secondary>
                                            <Header as='h4' content={nb.va_name}
                                                subheader={`Updated on ${this.getDateInSpecificFormat(nb.updated_at)}`} />
                                            <Menu.Menu position='right'>
                                                <Button id='remove-card-btn' size='mini'
                                                    onClick={() => { this.openDeleteConfirmationModal(nb) }}
                                                >{NARRATIVEBOARDCONFIG.BUTTONTEXT.REMOVECARD}</Button>
                                            </Menu.Menu>
                                        </Menu>
                                    </Card.Header>
                                    <Slider {...slider_settings}
                                        className={(narrative_board_msg.trim() !== '') ? 'card-slider-with-error-msg' : ''}
                                        beforeChange={(current, next) => this.handleSildeChange(nb.insight_id, next)}
                                    >
                                        {this.renderCardWithHistoryCards(nb.history, i)}
                                    </Slider>
                                    <NarrativeBoardComments teams_context={teams_context} auth_token={auth_token}
                                        narrative_board_team_members={narrative_board_team_members}
                                        narrative_board_card={this.getHistoryCard(nb, nb.insight_id)} nb_insight_id={nb.insight_id} />
                                </Card.Content>
                            </Card>
                        })}
                    </Card.Group>
                    : this.renderNoCardMessage()
                }
                {this.renderDeleteConfirmationModal()}

                {this.renderPaginationLoader()}

                {this.renderMessage()}
            </div>)
        }
        else {
            return <> </>;
        }
    }
}


/**
 * Maps the state to props for a component.
 * Extracts the narrative board cards, team members, messages, 
 * and various UI state indicators from the Redux store state.
 * 
 * @param {Object} state - The current Redux state of the application.
 * @returns {Object} A props object containing:
 * - narrative_board_cards: A deep copied list of narrative board cards.
 * - narrative_board_team_members: A deep copied list of narrative board team members.
 * - narrative_board_msg: The current narrative board message.
 * - theme: The current UI theme.
 * - show_loader: A boolean indicating whether the loader should be shown.
 * - nb_card_history_current_page_count: A deep copied list of current page counts for card history.
 * - nb_card_current_page_count: The current page count of narrative board cards.
 * - is_get_more_cards: A boolean indicating if more cards are being fetched.
 * - is_license_expire: A boolean indicating if the license has expired.
 * - is_unregisterd_user: A boolean indicating if the user is unregistered.
 * - unregisterd_user_msg: The message for unregistered users.
 * - active_loader: A boolean indicating if a loader is active.
 * - is_update_chart_view_state: A boolean indicating if the chart view state is updated.
 * - sessionId: The current session ID.
 */
const mapStateToProps = (state: any) => {
    let { narrative_board_cards, narrative_board_msg, show_loader,
        is_get_more_cards, nb_card_current_page_count, nb_card_history_current_page_count, narrative_board_team_members } = state.narrativeBoardState;
    let {sessionId} = state.viewState;
    return ({
        narrative_board_cards: JSON.parse(JSON.stringify(narrative_board_cards)),
        narrative_board_team_members: JSON.parse(JSON.stringify(narrative_board_team_members)),
        narrative_board_msg: narrative_board_msg,
        theme: state.viewState.theme,
        show_loader: show_loader,
        nb_card_history_current_page_count: JSON.parse(JSON.stringify(nb_card_history_current_page_count)),
        nb_card_current_page_count: nb_card_current_page_count,
        is_get_more_cards: is_get_more_cards,
        is_license_expire: state.viewState.is_license_expire,
        is_unregisterd_user: state.viewState.is_unregisterd_user,
        unregisterd_user_msg: state.viewState.unregisterd_user_msg,
        active_loader: state.viewState.active_loader,
        is_update_chart_view_state: state.cardLibraryState.is_update_chart_view_state,
        sessionId
    });
};

export default connect(mapStateToProps, {
    setNarrativeBoardMessage, activeLoader,storeSessionId,
    getNarrativeBoardCards, emptyNarrativeBoardCards, deleteNarrativeBoardCard,
    getNarrativeBoardCardHistory, setLoaderState, getNarrativeBoardCardsAndTeamMembers
})(NarrativeBoardTab);
